'use client'

import { ThemeProvider as NextThemesProvider } from 'next-themes'
import { type ThemeProviderProps } from 'next-themes/dist/types'

export const ThemeProvider = (props: ThemeProviderProps): React.JSX.Element =>
  NextThemesProvider(props) as React.JSX.Element
